export default {
    data() {
        return {
            // 当前页面
            currentPage: 1,
            //每页的数据
            pageLen: 15,
            //上传的文件
            fileListTwo: [],
            //上传的接口地址
            addressTwo: this.baseUrl + 'purchased/czUpload?token=' + this.$store.state.authority_management,
            //下载模板地址
            download: this.baseUrl + 'excel_template/czUpload.xlsx',
            //搜索学生的条件
            searchStudent: {
                name: '',
                company: '',
                phone: '',
                idcard: ''
            },
            //辨别是用条件搜索还是全部搜索学生=>默认全部
            searchType: true,
            // 当前选择课程的学员id
            // studentId: '',
            //学生总数量
            studentTotal: 0,
            //学生搜素当前页
            studentSearchCurrentPage: 0,
            //学生当前页
            studentCurrentPage: 0,
            //学生数据
            studnetData: [],
            //所有产品
            selectData: [],
            // 控制显示根据身份证批量生成学时证明
            showIdcard: false,
            // 身份证号数组
            idcards: '',
            // id数组
            idList: [],
            // 判断输入的身份证号是否正确 0 错误 1 正确
            flag: null
        }
    },
    methods: {
        httpreq(q) {
            this.$upload(this.addressTwo, q).then(res => {
                if (res.status == "200") {
                    this.$message({
                        message: "上传成功！",
                        type: "success"
                    })
                } else {
                    this.$message({
                        message: res.data.result.msg,
                        type: "error"
                    }); 
                }
            })
        },
        //该页每页要的数组
        handleSizeChange(val) {
            this.pageLen = val;
            this.getAllStudent();
        },
        //批量生成学时证明
        moreCreateCers() {
            if (this.paruseStudent.length == 0) {
                this.$message({
                    message: "请至少选择一个成员",
                    type: "error"
                });
                return false;
            }
            for (let id of this.paruseStudent) {
                this.createCers(id);
            }
        },
        //生成学时证明
        createCers(userIdList) {

            // 查询用户state==2的订单
            this.$post('orders/paid_order2', {
                token: this.$store.state.authority_management,
                owner_ids: JSON.stringify(userIdList),
                offset: 0,
                length: 999
            }).then(res => {
                // 得到订单数组
                let orderList = res.data.result.data;

                // 查询category_order表中对应的记录
                this.$post('category_order/get_by_orders', {
                    token: this.$store.state.authority_management,
                    order_ids: JSON.stringify(orderList),
                    offset: 0,
                    length: 999
                }).then(res2 => {
                    // 得到未生成证书的记录
                    let nullCerList = res2.data.result.data;

                    // 循环生成证书，并将记录修改为已生成证书
                    for (let item of nullCerList) {

                        // 创建证书
                        this.$post('cers/shop_create', {
                            token: this.$store.state.authority_management,
                            category_ids: JSON.stringify([item.category_id]),
                            cer_year: item.category_year,
                            pay_date: item.study_start_time,
                            end_date: item.study_end_time,
                            owner_id: item.user_id
                        }).then(res3 => {

                            if (res3.data.status === 'success') {
                                // 将对应的记录修改为已生成证书
                                this.$post('category_order/update', {
                                    id: item.id,
                                    is_first: 1,
                                    score: 100,
                                    category_progress: 1
                                });
                            }
                        });
                    }
                });
            }).then(() => {
                this.$message.success('批量生成学时证明成功');
                this.showIdcard = false;
                this.getAllStudent();
            }).catch((error) => {
                console.log(error);
                this.$message.error('批量生成学时证明失败，请稍后重试！');
            });
        },

        //搜索课程
        searchClass() {
            this.$post('products/search', { token: this.$store.state.authority_management, offset: 0, length: 15, shop_id: 1, name: this.classSearchName, onsale: "1" }).then(res => {
                this.selectData = res.data.result.data;
                this.classTotal = res.data.result.total;
            })
        },

        downloadProgress: function () {
            // console.log(this.download)
            window.open(this.download);
        },
        //确定搜索学生
        confirmSearch() {
            this.currentPage = 1
            this.searchType = false;
            let obj = {
                token: this.$store.state.authority_management,
                company: this.searchStudent.company,
                name: this.searchStudent.name,
                phone: this.searchStudent.phone,
                idcard: this.searchStudent.idcard,
                offset: this.studentCurrentPage,
                length: 15
            };
            this.$post('users/search', obj).then(res => {
                this.studnetData = res.data.result.data;
                this.studentTotal = res.data.result.total;
            })
        },

        //获取学生信息详情
        getStudent() {
            //输入密码框隐藏
            this.isPassword = false;
            //弹出框显示
            this.dialogFormVisible = true
            //把输入框变为不可输入
            this.isInput = {
                name: true,
                idCard: true,
                phone: true,
                company: true,
                email: true,
            }
        },
        //点击学员多选框
        handleStudentChange(val) {
            let arr = [];
            for (let item of val) {
                arr.push(item.id);
            }
            this.paruseStudent = arr;
        },

        //点击当前页面获取该有的信息
        getClassPage(currentPage) {
            this.classCurrentPage = (currentPage - 1) * 15;
            this.allClass(this.studentId);
        },
        //获取所有学生的信息
        getAllStudent() {
            this.searchType = true;
            this.$post('users/search', {
                token: this.$store.state.authority_management,
                offset: this.studentCurrentPage,
                length: 15,
                shop_id: this.$store.state.store.id,
                name: this.searchStudent.name,
                idcard: this.searchStudent.idcard
            }).then(res => {
                this.studentTotal = res.data.result.total;
                this.studnetData = res.data.result.data;
            })
        },
        //根据分页获取学生信息
        getStudentPage(currentPage) {
            this.currentPage = currentPage;
            if (this.searchType) {
                //根据点击的分页改变数据的偏移量
                this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
                //再请求对应的学生信息
                this.getAllStudent();
            } else {
                this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
                this.confirmSearch()
            }

        },
        //上传的一堆回调方法
        beforeUploadTwo(file) {
            let str = file.name;
            // console.log(file);
            if (str.substr(str.length - 4, 4).toLocaleLowerCase() != "xlsx") {
                alert('excel文件必须是xlsx格式')
                return false;
            }
        },
        handleRemoveTwo(file, fileList) {
            // console.log(file, fileList);
        },
        handlePreviewTwo(file) {
            // console.log(file);
        },
        handleExceedTwo(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemoveTwo(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        isOkTwo(response, file, fileList) {
            alert(response);
        },

        // // 显示根据身份证批量生成学生证明弹窗
        // showIdcardDialog() {
        //     this.showIdcard = true
        // },

        // 取消批量生成证明
        // colseGenerateProve() {
        //     this.showIdcard = false
        //     this.idcards = ''
        // },

        // // 批量生成学生证明
        // generateProve() {
        //     // this.showIdcard = false
        //     if (this.idcards.trim() === '') {
        //         this.$message({
        //             type: 'error',
        //             message: '最少输入一个身份证号'
        //         })
        //         return
        //     }
        //     let idcard_arr = this.idcards.trim().split('\n')

        //     // 检查输入的身份证是否有误
        //     // for (let i = 0; i < idcard_arr.length; i++) {
        //     //   this.getUserByIdcard(idcard_arr[i])
        //     //   if (this.flag === 0) {
        //     //     break
        //     //   }
        //     // }

        //     // 根据身份证号获取id
        //     this.getIdByIdcard(idcard_arr)
        // },

        // 根据身份证号数组获取id数组
        getIdByIdcard(idcard_arr) {
            this.$post('users/idcard_arr_id', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 9999,
                idcard_arr: JSON.stringify(idcard_arr),
                shop_id: this.$store.state.store.id
            }).then(res => {
                // console.log(res)
                if (res.data.result.total !== idcard_arr.length) {
                    this.$message({
                        type: 'error',
                        message: '您输入的身份证信息有误, 请重新输入'
                    })
                    return
                }
                let list = res.data.result.data
                list.map(i => {
                    this.idList.push(i.id * 1)
                });

                // this.idList.map(i => {
                //     this.createCers(i)
                // });

                // 生成证书
                this.createCers(this.idList);
                this.idcards = ''
            })
        },

        // 根据身份证获取用户
        getUserByIdcard(idcard) {
            this.$post('users/user_by_idcard', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 9999,
                idcard: idcard
            }).then(res => {
                // console.log(res)
                // 判断根据输入的身份证是否能查到用户
                if (res.data.result.data.length === 0) {
                    this.$message({
                        type: 'error',
                        message: `输入的身份证号: ${idcard} 有误, 请检查后输入`
                    })
                    this.flag = 0
                    // console.log(this.flag)
                }
            })
        }
    },
    created() {
        this.getAllStudent();
    }

}
